export const GET_INITIAL_SERVICES = 'GET_INITIAL_SERVICES';
export const FETCHED_SERVICE_CHILDREN = 'FETCHED_SERVICE_CHILDREN';
export const CREATED_SERVICE_SUCCESSFUL = 'CREATED_SERVICE_SUCCESSFUL';
export const EDITED_SERVICE_SUCCESSFUL = 'EDITED_SERVICE_SUCCESSFUL';
export const REMOVED_SERVICE_SUCCESSFUL = 'REMOVED_SERVICE_SUCCESSFUL';
export const FETCHED_PARENT_SERVICES = 'FETCHED_PARENT_SERVICES';
export const SHOW_EXTENSION_MODAL = 'SHOW_EXTENSION_MODAL';
export const FETCHED_CATALOGUE_SERVICE = 'FETCHED_CATALOGUE_SERVICE';
export const CREATE_SERVICE_PRICE_SUCCESSFUL = 'CREATE_SERVICE_PRICE_SUCCESSFUL';
export const UPDATE_SERVICE_PRICE_SUCCESSFUL = 'UPDATE_SERVICE_PRICE_SUCCESSFUL';
export const DELETE_SERVICE_PRICE_SUCCESSFUL = 'DELETE_SERVICE_PRICE_SUCCESSFUL';
export const SUCCESSFUL_FETCHED_SERVICES = 'SUCCESSFUL_FETCHED_SERVICES';


// WEBPACK FOOTER //
// ./src/actionTypes/service.js